module.exports = __webpack_public_path__ + "img/existing-app.d8c39cfc.png";